import React from "react";
import Breadcrumb from "../component/breadcrumb/breadcrumb";
import HeroHomeAttendant from "../component/Hero/HeroHomeAttendant";
import medicalEquipmentHeroImg from "../assets/medical-equipment-hero-img.png";
import { Container, Row, Col } from "react-bootstrap";
import Mobile from "../component/mobile/mobile";
import EquipmentAllType from "../component/EquipmentAllType/EquipmentAllType";
import { CiLocationOn } from "react-icons/ci";
import nursingservice1 from '../assets/Orthopedic-and-Physiotherapy-Care.png';

const MedicalEquipment = () => {
  return (
    <>
      <HeroHomeAttendant img={medicalEquipmentHeroImg} />
      <div className="medical-equipment-text">
        <Container>
           <Row className="mt-4 bdrs p-4 mb-5">
                      <Col lg={2} className="d-flex justify-content-center align-items-center">
                        <div
                          className="d-flex align-items-center"
                          style={{
                            backgroundColor: "#D8E7FF",
                            borderRadius: "50%",
                            width: "130px",
                            height: "130px",
                          }}
                        >
                          <img src={nursingservice1} width={"120px"} height={"100px"} />
                        </div>
                      </Col>
                      <Col lg={10}>
                        <div>
                          <p className="fw-bolder fs-4 ms-3">
                            Shree Hari Pathology Laboratory
                          </p>
                          <p className="text-primary">
                            <CiLocationOn className="fs-5 me-2" />
                            110, Shreeji Complex, Near Hira Baug Circle Varachha Road,
                            Surat - 395006
                          </p>
                          <p className="ms-3" style={{ textAlign: "justify" }}>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit
                            egestas id gravida. Libero convallis diam vulputate et
                            volutpat risus amet dolor. Blandit urna sagittis, nibh at
                            vitae nunc. Magnis fringilla of bibendum dictumst lorem non
                            placerat eu et velit. In diam imperdiet imperdiet seeed tortor
                            main suspendisse. consectetur adipiscing elit egestas id
                            gravida. Libero convallis diam vulputate et volutpat risus
                            amet dolor. Blandit urna sagittis, nibh at vitae nunc.
                          </p>
                        </div>
                      </Col>
                    </Row>
        </Container>
       
        <Container>
          <div className="row">
            <h4>How Can we Help</h4>
            <p>
              If you need any medical equipment for rent, get it from Tech
              Tricks. Check our exhaustive medical equipment catalogue and rent
              your required one online, via email or over a phone call. Your
              equipment will be delivered at your doorstep
            </p>
          </div>
        </Container>
      </div>
      <EquipmentAllType />
      <Mobile />
    </>
  );
};

export default MedicalEquipment;
